import { render, staticRenderFns } from "./SubSectionPopulation.vue?vue&type=template&id=5e006087&scoped=true"
import script from "./SubSectionPopulation.vue?vue&type=script&lang=js"
export * from "./SubSectionPopulation.vue?vue&type=script&lang=js"
import style0 from "./SubSectionPopulation.vue?vue&type=style&index=0&id=5e006087&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e006087",
  null
  
)

export default component.exports